export const AUDIT_LOG_STATUS = {
  PENDING: 'Pending',
  SUCCESS: 'Success',
  FAILED: 'Failed',
  REJECTED: 'Rejected', // reject credit notes
} as const;

export const SCAN_AUDIT_LOG_PER_PAGE = 10;
